import { useEffect, useState, useRef } from "react";
import Skeleton from "react-loading-skeleton";
import Prestation from "./prestation";

const ServicesRdv = ({ services, status, buttonAction }) => {
  const [selectedService, setSelectedService] = useState(null);
  const sliderRef = useRef(null);
  const [sliderPosition, setSliderPosition] = useState(0);
  const [maxPosition, setMaxPosition] = useState(0);

  // Initialize default selected service and max position
  useEffect(() => {
    if (services && services.length > 0) {
      setSelectedService(services[0]);
      calculateMaxPosition();
    }
  }, [services]);

  // Calculate max scroll position
  const calculateMaxPosition = () => {
    if (sliderRef.current) {
      const containerWidth = sliderRef.current.offsetWidth;
      const contentWidth = sliderRef.current.scrollWidth;
      setMaxPosition(contentWidth - containerWidth);
    }
  };

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      calculateMaxPosition();
      // Adjust position if needed after resize
      if (sliderRef.current) {
        sliderRef.current.scrollLeft = sliderPosition;
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [sliderPosition]);

  // Loading state
  if (status === "loading") {
    return (
      <div className="etablissement-services mt-24">
        <div className="single row">
          <div className="services-col col-md-8">
            <h3 className="grey500">
              <Skeleton width={200} />
            </h3>
            <div className="service-cards">
              {[...Array(5)].map((_, index) => (
                <div key={index} className="service-card">
                  <Skeleton width={150} />
                </div>
              ))}
            </div>
          </div>
          <div className="hours-col col-md-4">
            <Skeleton width="100%" height={300} />
            <Skeleton width="100%" height={300} style={{ marginTop: "8px" }} />
          </div>
        </div>
      </div>
    );
  }

  if (!services || services.length === 0) {
    return <div>No services available.</div>;
  }

  const handleScroll = (direction) => {
    if (!sliderRef.current) return;

    const containerWidth = sliderRef.current.offsetWidth;
    const scrollAmount = containerWidth * 0.8; // Scroll 80% of container width

    let newPosition;
    if (direction === 'next') {
      newPosition = Math.min(sliderPosition + scrollAmount, maxPosition);
    } else {
      newPosition = Math.max(sliderPosition - scrollAmount, 0);
    }

    sliderRef.current.scrollTo({
      left: newPosition,
      behavior: 'smooth'
    });
    setSliderPosition(newPosition);
  };

  const handleServiceSelect = (service) => {
    setSelectedService(service);
  };

  return (
    <div className="etablissement-services mt-24">
      <div className="single row">
        <div className="services-col">
          <h3 className="grey500">Prestations</h3>

          <div className="service-slider-container d-flex align-items-center">
            <div 
              className="service-cards"
              ref={sliderRef}
              onScroll={(e) => setSliderPosition(e.target.scrollLeft)}
            >
              {services.map((service) => (
                <div
                  key={service.id}
                  className={`service-card ${
                    selectedService?.id === service.id ? "active" : ""
                  }`}
                  onClick={() => handleServiceSelect(service)}
                >
                  {service.name}
                </div>
              ))}
            </div>

            <div className="slider-controls">
              <button
                onClick={() => handleScroll('prev')}
                className="link-blue"
                disabled={sliderPosition <= 0}
              >
                <img src="/images/left.svg" alt="Previous" />
              </button>
              <button
                onClick={() => handleScroll('next')}
                className="link-blue"
                disabled={sliderPosition >= maxPosition}
              >
                <img src="/images/left.svg" alt="Next" className="rotate180" />
              </button>
            </div>
          </div>

          {selectedService && (
            <div className="prestations">
              {selectedService.prestations && selectedService.prestations.length === 0 ? (
                <p className="body grey66">
                  Aucune prestation disponible pour ce service.
                </p>
              ) : (
                selectedService.prestations.map((prestation, index) => (
                  <Prestation
                    key={index}
                    prestation={prestation}
                    selected={false}
                    classNameBtn="twyny-cta-secondary"
                    buttonAction={() => buttonAction(prestation)}
                    buttonName="Choisir"
                  />
                ))
              )}
            </div>
          )}
        </div>
        <div className="hours-col col-md-4"></div>
      </div>
    </div>
  );
};

export default ServicesRdv;